import { render, staticRenderFns } from "./CampaignDetail.vue?vue&type=template&id=772e889e&scoped=true"
import script from "./CampaignDetail.vue?vue&type=script&lang=js"
export * from "./CampaignDetail.vue?vue&type=script&lang=js"
import style0 from "./CampaignDetail.vue?vue&type=style&index=0&id=772e889e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772e889e",
  null
  
)

export default component.exports